module.exports = __webpack_public_path__ + "static/media/splash-photo-right.fd23a7be.jpg";